import axios from 'axios';
import config from '../config';
import { getBearerToken } from '../util/cookie';

// ── Action types ──
export const MOOD_REQUEST = 'app/CoachSaaS/MOOD_REQUEST';
export const MOOD_SUCCESS = 'app/CoachSaaS/MOOD_SUCCESS';
export const MOOD_ERROR = 'app/CoachSaaS/MOOD_ERROR';

const initialState = {
  entries: [],
  moodFetching: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case MOOD_REQUEST: return { ...state, moodFetching: true };
    case MOOD_SUCCESS: return { ...state, moodFetching: false, entries: payload };
    case MOOD_ERROR: return { ...state, moodFetching: false };
    default: return state;
  }
}

// ── Thunks ──
export const submitMood = (payload) => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}client/mood/submit`,
    { payload },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const fetchRecentMood = (days = 30) => async (dispatch, getState, sdk) => {
  dispatch({ type: MOOD_REQUEST });
  try {
    const res = await axios.post(
      `${config.coachSaaSService}client/mood/recent`,
      { days },
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    );
    dispatch({ type: MOOD_SUCCESS, payload: (res.data && res.data.entries) || [] });
    return res.data;
  } catch (e) {
    dispatch({ type: MOOD_ERROR });
    throw e;
  }
};
